import { replaceTokensInString } from '@app/utils';
import PropTypes from 'prop-types';
import {
  AlloyButton,
  AlloyIcon,
  Popup,
  PopupTrigger
} from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import PurifiedHtml from '@app/components/common/PurifiedHtml';
import styles from './CopyAndPastePopup.module.scss';

const CopyAndPastePopup = ({ trigger = PopupTrigger.CLICK }) => {
  const { t } = useTranslation();

  const boldOne = `<b className="m-0 fw-bold line-height-14">
      ${t('QUICK_ORDER_SEPERATED_LIST')}
    </b>`;
  const boldTwo = `<b className="m-0 fw-bold line-height-14">
      ${t('QUICK_ORDER_EXCEL_TABLE')}
    </b>`;
  const columnHeaders = `<em className="m-0 fst-italic line-height-14">
      ${t('QUICK_ORDER_TABLE_COLUMNS')}
    </em>`;
  const text = replaceTokensInString(
    t('QUICK_ORDER_PASTE_LIST'),
    boldOne,
    boldTwo,
    columnHeaders
  );
  const descriptionClassName = 'text-xs text-justify mb-3 u-color--DarkGray';
  const exampleClassName = 'u-color--DarkGray';
  const itemNotesText = t('QUICK_ORDER_ITEM_NOTES');

  return (
    <div className="mt-0 pt-0">
      <span className={`m-0 mt-1 ${exampleClassName}`}>
        {t('QUICK_ORDER_PASTE_TITLE')}
      </span>
      <Popup
        contents={
          <div className={styles['product-form__copy-paste-popup']}>
            <p className="mb-3 text-xs text-uppercase u-color--ExtraDarkGray fw-bold">
              {t('QUICK_ORDER_PASTE_TITLE')}
            </p>
            <PurifiedHtml
              as="p"
              className={descriptionClassName}
              htmlString={text}
            />
            <p className={descriptionClassName}>
              {t('QUICK_ORDER_PASTE_HELP')}
            </p>
            <p className={`${descriptionClassName} fw-bold`}>
              {t('FOR_EXAMPLE')}:
            </p>
            <p className={`text-xs ${exampleClassName}`}>
              {`10, 1R-0734, 246B, “${itemNotesText}.”, 1S2D4F, 555623`}
              <br />
              {`3, 250-0486, CC34B, “${itemNotesText}.“`}
              <br />
              {'5, 4C-3322'}
              <br />
              {'2, 6T-3642'}
            </p>
          </div>
        }
        initiator={
          <AlloyButton className="m-0 px-1" buttonType="ghost">
            <AlloyIcon icon="icon-info" className="u-fill--DarkGray" />
          </AlloyButton>
        }
        popperOptions={{ placement: 'bottom-start' }}
        trigger={trigger}
      />
    </div>
  );
};

CopyAndPastePopup.propTypes = {
  trigger: PropTypes.string
};
export default CopyAndPastePopup;
